import {connect} from 'react-redux';
import React, {Component} from 'react';

import LanguageSelect from './LanguageSelect';
import * as RoutePath from '../../constants/RoutePaths';

import {
    logout,
    showRegModal,
    showAuthModal
} from '../../actions/User';

const defaultProps = {
    logout: () => {
    },
    showRegModal: isShowRegModal => {
    },
    showAuthModal: isShowAuthModal => {
    }
};

class MobileLine extends Component {
    showAuthModal(event, isShowAuthModal) {
        event.preventDefault();

        this.props.showAuthModal(isShowAuthModal);
    }

    showRegModal(event, isShowRegModal) {
        event.preventDefault();

        this.props.showRegModal(isShowRegModal);
    }

    logout(event) {
        event.preventDefault();
        const {logout, match, history} = this.props;

        logout();
        if (match.path === RoutePath.CREATING_OBJECT) {
            history.push(RoutePath.HOME);
        }
    }

    getDisplayName() {
        let {currentUser} = this.props;

        if (currentUser == null || currentUser == undefined) {
            return '';
        }

        if (currentUser.firstName != null && currentUser.lastName != null) {
            return currentUser.firstName + " " + currentUser.lastName;
        }
        if (currentUser.firstName != null && currentUser.lastName == null) {
            return currentUser.firstName;
        }
        if (currentUser.firstName == null && currentUser.lastName != null) {
            return currentUser.lastName;
        }

        return currentUser.email;
    }

    render() {
        const i18n = this.props.languages.i18n;
        let {user} = this.props;
        // todo: "/files/users/" + user.currentUser.userId + "/avatar" - вынести в отдельную функцию можнол
        return (
            <div className="mobile-line">
                <LanguageSelect/>
                {this.props.user.currentUser.accessToken === null ? (
                    <div className="login-box">
                        <a
                            href=""
                            className="link link-login"
                            onClick={(event) => this.showAuthModal(event, true)}
                        >
                            {i18n['layout.login']}
                        </a>
                        <span>|</span>
                        <a
                            href=""
                            className="link link-reg"
                            onClick={(event) => this.showRegModal(event, true)}
                        >
                            {i18n['layout.register']}
                        </a>
                    </div>
                ) : (
                    <div className="login-box d-flex">
                        <a href={"/crm"} className="user-box">
                            <img src={"/files/users/" + user.currentUser.userId + "/avatar"} alt=""
                                 className="user-box-img"/>
                            <span className="user-box-text">{this.getDisplayName()}</span>
                        </a>
                        <span className="mrgn-h-xs">|</span>

                        <a href="" onClick={::this.logout} className="link link-login">{i18n['layout.logout']}</a>
                    </div>
                )}
            </div>
        )
    }
}

MobileLine.defaultProps = defaultProps;

const mapStateToProps = state => ({
    user: state.user,
    currentUser: state.user.currentUser,
    languages: state.languages
});

const mapDispatchToProps = {
    logout,
    showRegModal,
    showAuthModal
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileLine);



// WEBPACK FOOTER //
// ./src/components/Base/MobileLine.js